const MS_PER_DAY = 24 * 60 * 60 * 1000;


/**
 * Whole days remaining until `trialEndsAt`, rounded up (`Math.ceil`) and clamped
 * at 0 so an elapsed trial never returns a negative. Returns `null` when there is
 * no trial end to count down. Shared by the subscription banner, dashboard, and
 * billing page so the countdown rule stays in one place.
 */
function trialDaysLeft(trialEndsAt) {
  if (!trialEndsAt) {
    return null;
  }
  const left = Math.ceil((new Date(trialEndsAt) - Date.now()) / MS_PER_DAY);
  return left > 0 ? left : 0;
}


export { MS_PER_DAY, trialDaysLeft };
